import BaseValidator from 'services/validations/base-validator';

class StackPlayersValidator extends BaseValidator {
    protected runValidation(): void {
        // @ts-ignore
        const {stacking, players} = this.dependencies;
        const items = stacking.getItems();

        items.forEach((item) => {
            let stackPlayers = item.getFirstTeamStackPlayers();

            let availablePlayersQuantity = 0;
            stackPlayers.forEach((stackPlayer) => {
                if (players.hasOwnProperty(stackPlayer.getId())) {
                    availablePlayersQuantity++;
                }
            });

            if (item.getFirstTeamAtLeastPlayers() > availablePlayersQuantity) {
                this.addError('Quantity of available players is not enough.');
            }

            if (item.isGameStackType()) {
                stackPlayers = item.getSecondTeamStackPlayers();

                availablePlayersQuantity = 0;
                stackPlayers.forEach((stackPlayer) => {
                    if (players.hasOwnProperty(stackPlayer.getId())) {
                        availablePlayersQuantity++;
                    }
                });

                if (item.getSecondTeamAtLeastPlayers() > availablePlayersQuantity) {
                    this.addError('Quantity of available players is not enough.');
                }
            }
        });
    }
}

export default StackPlayersValidator;
